export enum EService {
  NONE = 'NONE', // 无需搬运
  PLATFORMCALC = 'PLATFORMCALC', // '平台 计价'
  OFFER = 'OFFER', // 我来报价
  OFFLINE = 'OFFLINE', // 和司机线下商议
}

export enum EServiceName {
  NONE = '无需搬运', // 无需搬运
  PLATFORMCALC = '需要搬运(平台计价)', // '平台计价'
  OFFER = '我来报价', // 我来报价
  OFFLINE = '需要搬运(和司机线下商议)', // 和司机线下商议
}

export interface IItem {
  value: EService;
  label: string;
}

// 校验规则
export interface IRule {
  value: any;
  required?: boolean;
  message: string;
  pattern?: RegExp;
  max?: number;
  silent?: boolean; // 是否弹出warning信息
}

// 报价方式枚举值
export enum EWays {
  CHARGE_BY_PIECE = 'CHARGE_BY_PIECE', // 按件收费
  CHARGE_BY_KG = 'CHARGE_BY_KG', // 按千克收费
  CHARGE_BY_TON = 'CHARGE_BY_TON', // 按吨收费
  CHARGE_BY_VOLUME = 'CHARGE_BY_VOLUME', // 按体积收费
  CHARGE_BY_WORKER = 'CHARGE_BY_WORKER', // 按师傅人数收费
  CHARGE_BY_USER_DEFINED = 'CHARGE_BY_USER_DEFINED', // 按用户自定义报价收费
  WEIGHT = 'WEIGHT',
}

export interface IWay {
  label: string;
  value: EWays;
  name: string;
  placeholder?: string;
  countName?: string;
  countUint?: string;
}

export interface IGoods {
  id: string;
  level: number;
  name: string;
  parentId: string;
  parentLevel: number;
  parentName: string;
}

export interface ModalProps {
  onClose: VoidFunction;
  visible: boolean;
  config: CartageChargesConfig;
  taxText: string;
}

export interface CartageChargesConfig {
  porterageConfigDetail: PorterageConfigDetail[];
  vehicleName: string;
  taxRate: string | number;
}

export interface PorterageConfigDetail {
  bigItemBaseFee: number;
  packageDesc: string;
  packageType: number;
  porterageBaseFee: number;
  porterageBigItemFee: number;
  porterageFloorFee: number;
}

export interface PorteragePointParamItem {
  name: string; // 当前点位名称
  index: number; // 第几个搬运点 起点为1
  floor: number; // 楼层数 不需要搬运传0
  needPorterage: number; // 是否搬运 1: 不搬运 2: 搬运
  haveElevator: number; // 有无电梯 0: 其他 1: 无 2: 有
  bigItemTotal: number; // 大件数量 不需要搬运或者没有 传0
}
export interface PorterageDetail {
  porteragePointParam: PorteragePointParamItem[];
  packageType: number; // 套餐类型 0: 不需要搬运 1: 整车 2: 半车
  cityId: number; // 城市id
  orderVehicleId: number; // 企业车型ID
}

export interface CartageDrawerProps {
  visible: boolean;
  cartageConfig: any;
  porterageConfigCtrl: PorterageDetail | undefined;
  porterageCalc: any;
  onCancel: VoidFunction;
  onSubmit: (val: any) => void;
  calcPlatform: (val: any) => void;
  drawerForm: any; // 地址数量不确定
  openPriceDetail: (val: any) => void;
  hasTaxFee: boolean;
}

export interface CartagePriceDetailProps {
  visible: boolean;
  onClose: () => void;
  openChargesModal: (val: any) => void;
  porterageCalc: Record<string, any> | undefined;
  hasTaxFee: boolean;
  taxText: string;
}

export interface CartagePoptipProps {
  porterageCalc: Record<string, any> | undefined;
  porterageConfigCtrl: PorterageDetail | undefined;
  drawerForm: Record<string, any> | undefined;
  openDraw: (val: any) => void;
  openPriceDetail: (val: any) => void;
  hasTaxFee: boolean;
}
